import React, { useEffect } from "react";

import Breadcrumb from "../../../components/common/Breadcrumb";

import { NavLink } from "react-router-dom";
import UpcomingBookings from "../../../components/common/UpcomingBookings/UpcomingBookings";
import { useDispatch } from "react-redux";
import { clearDatahandling } from "../../../utils/clearDataHandling";

const OrderPending = () => {
  const dispatch = useDispatch()
  useEffect(() => {
    clearDatahandling(dispatch)

  }, [])
  return (
    <>
      <div className="booking-details-sec order-details-wrap">
        <div className="booking-details-wrap max-720 mb-4">
          <div className="upcoming-sec">
            <h2>My Orders</h2>

            <div className="bre-wrap ">
              <Breadcrumb />
              <NavLink to="/booking">Back to My Bookings</NavLink>
            </div>

            <div className="booking-details-box">
              <div className="booling-id-wrap d-flex align-items-center">
                <div className="booling-id">ORDER #2309-12345</div>

                <div className="up-green up-yellow">
                  <p className="mb-0">PENDING</p>
                </div>
              </div>

              <div className="upcoming-heading-wrap ">
                <div className="d-flex align-items-center justify-content-between">
                  <div className="cl-heading-wrap gray-bg">
                    <div className="upcoming-heading">
                      <h5>
                        Regular Cleaning
                      </h5>
                    </div>
                    <p className="mb-0">28 Aug 2023, Saturday </p>
                    <p className="mb-0">0900 - 1300</p>
                  </div>
                  <div className="order-details-right">
                    <h5>$415.50</h5>
                    <p className="mb-0">
                      {" "}
                      Invoice: <NavLink to="/">INV202309-000123</NavLink>
                    </p>
                    <p className="mb-0">Paid: 15 Aug 2023, 05:54</p>
                  </div>
                </div>
              </div>

              <div className="service-row">
                <div className="row">
                  <div className="col-md-6">
                    <div className="service-row-col-wrap">
                      <h3>Order Details</h3>
                      <div className="sm-det">
                        <h5>Date and Time</h5>
                        <p>21 Aug 2023, 09:00 - 13:00 (First session)</p>
                      </div>
                      <div className="sm-det">
                        <h5>Service Location</h5>
                        <h6>SengKang</h6>
                        <p>Blk 330 Anchorvale Road #03-03 Singapore 541330</p>
                      </div>
                      <div className="sm-det">
                        <h5>Service Staff</h5>
                        <p>Mary Doe</p>
                      </div>
                      <div className="sm-det">
                        <h5>Other info</h5>
                        <p>Beware of cute dogs</p>
                      </div>
                    </div>
                  </div>
                  <div className="col-md-6">
                    <div className="service-row-col-wrap">
                      <h3>Services Booked</h3>
                      <div className="sm-det">
                        <h5>Services Booked</h5>
                        <p>Regular Cleaning </p>
                        <p>
                          12 Sessions, Twice weekly, Tuesday, Friday, 4 hours,
                          Night Cleaning{" "}
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className="transaction-sec max-720 mb-4">
          <h2>Transaction</h2>
          <div className="row">
            <div className="col-md-6">
              <div className="transaction-col">
                <h4>Date and Time </h4>
                <p>15 Aug 2023, 05:54</p>
              </div>
            </div>
            <div className="col-md-6">
              <div className="transaction-col">
                <h4>Payment Method </h4>
                <p>PayNow</p>
              </div>
            </div>
            <div className="col-md-6">
              <div className="transaction-col">
                <h4>Transaction ID</h4>
                <p>E-20140925112834-6023055 </p>
              </div>
            </div>
            <div className="col-md-6">
              <div className="transaction-col">
                <h4>Amount </h4>
                <p>$415.50</p>
              </div>
            </div>
          </div>
        </div>





      </div>
    </>
  );
};

export default OrderPending;
